import { useState, useEffect } from 'react';
import axios from './../Utils/instanceAxios';
import { QA_ENDPOINT, PRODUCTION_ENDPOINT } from '../constants/endpoints';

export const useFetch = (argParams) => {
  const BASE_URL = PRODUCTION_ENDPOINT || QA_ENDPOINT;
  const { initialUrl, initialParams = {}, skip, initialBody, headers = {} } = argParams;

  const token = localStorage.getItem('token');
  const user = localStorage.getItem('user');
  let username = '';

  try {
    username = JSON.parse(user).username;
  } catch {
    console.log('No user in local storage');
  }
  const [url, updateUrl] = useState(initialUrl);
  const [params, updateParams] = useState(initialParams);
  const [body, updateBody] = useState(initialBody);
  const [data, setData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [hasError, setHasError] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [refetchIndex, setRefetchIndex] = useState(0);

  const queryString = Object.keys(params)
    .map((key) => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`)
    .join('&');

  const refetch = () => setRefetchIndex((prevRefetchIndex) => prevRefetchIndex + 1);

  useEffect(() => {
    let isCancelled = false;
    const controller = new AbortController();

    const fetchData = async () => {
      if (skip) return;
      setIsLoading(true);
      try {
        const response = await axios.get(
          `${BASE_URL}${url}${queryString ? '?' : ''}${queryString}`,
          {
            headers: {
              'Content-type': 'application/json; charset=UTF-8',
              Authorization: token,
              ...(username ? { username } : {}),
              ...headers,
            },
            signal: controller.signal,
          },
        );
        if (!isCancelled) {
          const result = await response.data;
          setData(result);
        }
      } catch (err) {
        if (!isCancelled && err.name !== 'CanceledError') {
          setHasError(true);
          setErrorMessage(err.message);
        }
      } finally {
        if (!isCancelled) {
          setIsLoading(false);
        }
      }
    };
    fetchData();

    // Cleanup function to prevent state updates after unmount
    return () => {
      isCancelled = true;
      controller.abort();
    };
  }, [url, params, refetchIndex, body, skip, queryString, BASE_URL, token]);

  return {
    data,
    isLoading,
    hasError,
    errorMessage,
    updateUrl,
    updateParams,
    refetch,
    updateBody,
  };
};
